<template>
    <div class="main">
        <div class="queryButton">
            <a-row>
                <a-col offset="1">
                    <a-button class="bt1" type="primary" size="small" @click="query">{{$t('job.Query')}}</a-button>
                    <!--                        <a-button class="bt1" type="primary" size="small" @click="add">{{$t('generic.Add')}}</a-button>-->
                    <a-button class="bt1" type="primary" size="small" @click="refresh">{{$t('printerConfig.refresh')}}</a-button>
                    <a-button class="bt1" type="primary" size="small" @click="saveServices">{{$t('userlang.Save')}}</a-button>
                    <a-button class="bt1" type="primary" size="small" @click="deletePrintService">{{$t('generic.Delete')}}</a-button>
                    <!--                        <a-button class="bt1" type="primary" size="small" @click="saveServices">{{$t('job.Activate')}}</a-button>-->
                    <!--                        <a-button class="bt1" type="primary" size="small" @click="saveServices">{{$t('job.Inactivate')}}</a-button>-->
                </a-col>
            </a-row>
        </div>
        <div class="queryButton">
            <a-form :form="formQuery">
                <a-row>
                    <a-col offset="1">
                        <div class="queryParam">
                            <a-form-item  class="genericFrom" label="Service Name:">
                                <a-input ref="serviceName" size="small" v-decorator="['serviceName']" @pressEnter="query"/>
                            </a-form-item>
                        </div>
                        <div class="queryParam">
                            <a-form-item class="genericFrom"  label="IP:">
                                <a-input ref="ip"  size="small" v-decorator="['ip']" @pressEnter="query" />
                            </a-form-item>
                        </div>
                        <!--                            <div class="queryParam">-->
                        <!--                                <a-form-item class="genericFrom"  label="Printer:">-->
                        <!--                                    <a-input ref="printerName"  size="small" v-decorator="['printerName']" @pressEnter="query" />-->
                        <!--                                </a-form-item>-->
                        <!--                            </div>-->
                        <div class="queryParam">
                            <a-form-item class="genericFrom" label="Printer:">
                                <a-input size="small" v-decorator="['printerName']" @pressEnter="query" />
                            </a-form-item>
                        </div>
                        <div class="queryParam">
                            <a-form-item label="Select Printer">
                                <a-select size="small" v-decorator="['printer']" @change="printerChange">
                                    <a-select-option v-for="item in printer" :value="item">{{item}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <a-row>
            <!--列表-->
            <vxe-table
                    border
                    resizable
                    stripe
                    column-key
                    highlight-hover-column
                    highlight-hover-row
                    highlightCurrentRow
                    show-header-overflow
                    show-overflow
                    :sort-config="{multiple: true, trigger: 'cell'}"
                    :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                    keep-source
                    :keyboard-config="{isArrow: true}"
                    :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                    align="center"
                    :data.sync="PagingGridList"
                    class="mytable-style "
                    ref="pagingGrid"
                    size="mini">
                <template v-slot:empty>
                    <a-empty></a-empty>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                <vxe-table-column field="serviceName" :title="$t('printerConfig.servicesName')" width="200" sortable ></vxe-table-column>
                <vxe-table-column field="ip" :title="$t('printerConfig.ip')" width="200" sortable></vxe-table-column>
                <vxe-table-column field="printerName" :title="$t('printerConfig.printerName')" width="200" sortable></vxe-table-column>
                <vxe-table-column field="status" :title="$t('generic.Status')" width="200" sortable></vxe-table-column>
                <vxe-table-column field="createTime" :title="$t('generic.CreateTime')" width="200" sortable ></vxe-table-column>
            </vxe-table>
        </a-row>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    // import webSocketPrint from "./webSocketPrint";

    export default{
        props:{
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data() {
            return {
                ip:'',
                formQuery: this.$form.createForm(this, {}),
                printer:[],
                PagingGridList: [],//列表数据
            }
        },
        created() {
            this.query();
            console.info("页面创建成功")
            // this.queryProject();
        },
        methods:{
            add(){
                console.info("新增")
                this.formQuery.resetFields();
                var data = "";
                let that = this;
                ajax.get(api.GETUSERNAME).then(res => {
                    if(res.code == 200){
                        data = res.data;
                        that.form
                        that.$refs.serviceName.disabled="disabled";
                        that.$refs.serviceName.value=data;
                        that.$refs.ip.focus();
                    }
                })

            },
            refresh(){
                // var ip=this.$refs.ip.value;
                // if(""==ip||null==ip){
                //     this.$customMessage.warning("Please enter the IP!")
                //     return;
                // }
                // if(ip!=this.ip){
                //     this.$customMessage.warning("Non local IP, please enter the printer name!")
                //     return;
                // }
                let that=this;
                console.info("刷新打印机列表")
                if ("WebSocket" in window)
                {
                    console.info("您的浏览器支持 WebSocket!");
                    // 创建一个 websocket
                    var ws = new WebSocket("ws://localhost:9999/print");
                    ws.onopen = function()
                    {
                        // Web Socket 已连接上，使用 send() 方法发送数据
                        ws.send("{'Type':'SERVER_INFO'}");
                        console.info("数据发送中...");
                    };
                    ws.onmessage = function (evt)
                    {
                        var msg = evt.data;
                        var printers = JSON.parse(msg).printerServer.printers;
                        var printerArray = new Array();
                        for(var i = 0;i<printers.length;i++){
                            printerArray[i] = printers[i].name;
                        }
                        that.printer=printerArray;
                        console.info("数据已接收..."+msg);
                    };
                    ws.onclose = function()
                    {
                        // 关闭 websocket
                        console.info("连接已关闭...");
                    };
                }
                else
                {
                    // 浏览器不支持 WebSocket
                    console.info("您的浏览器不支持 WebSocket!");
                }
            },
            query(){
                // var Ip=returnCitySN['cip']
                // var cityname=returnCitySN['cname']
                // localStorage.setItem('Ip', Ip)
                // console.log(localStorage.getItem('Ip', Ip))
                // localStorage.setItem('cityname', cityname)
                // console.log(localStorage.getItem('cityname', cityname))
                this.formQuery.validateFields((err, values) => {
                    // webSocketPrint.doPrint("9999","test");
                    let params = values
                    params.rtMasterUid = this.headerUid
                    ajax.get(api.GETREPORTPRINTSERVICES, values).then(res => {
                        if(res.code == 200){
                            this.PagingGridList = res.msg;//列表
                        }
                    })
                });
            },
            // 获取用户本地ip的方法
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },
            saveServices(){
                var serviceName = this.$refs.serviceName.value;
                if(null==serviceName||""==serviceName){
                    this.$customMessage.warning("Please click the Add button!");
                    return;
                }
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(null==values.ip||""==values.ip){
                        this.$customMessage.warning("Please fill in IP!");
                        return;
                    }
                    if(null==values.printerName||""==values.printerName){
                        this.$customMessage.warning("Please fill in Printer!");
                        return;
                    }
                    if(values){
                        let params = values
                        params.rtMasterUid = this.headerUid
                        params.serviceName = serviceName;
                        ajax.post(api.SAVEREPORTPRINTSERVICES, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg,2);
                                this.formQuery.resetFields();
                                this.query();
                            } else {
                                this.$customMessage.warning(res.msg,2);
                            }
                        })
                    }
                });
            },
            deletePrintService(){
                let Records = this.$refs.pagingGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let uidList = [];
                for(let i in Records){
                    uidList.push(Records[i].uid)
                }
                let that = this;
                this.$customConfirm({
                    title: this.$t('pubGicSet.AreyoudeleTask'),
                    okText: this.$t('publicLang.Confirm'),
                    cancelText: this.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        let params = new FormData();
                        params.append("uidList", uidList);
                        ajax.post(api.DELETEPRINTSERVICES, params).then(res => {
                            if (res.code == 200) {
                                that.query()
                                that.$message.success(res.msg)
                            } else {
                                that.$customMessage.warning(res.msg);
                            }
                        })
                    }
                });
            },
            printerChange(val){
                let printerName = val;
                this.formQuery.setFieldsValue({
                    printerName:printerName
                })
            }
        },
        mounted(){
            this.getUserIP((ip) => {
                this.ip = ip;

            });
        }
    }
</script>
<style>
    .sortable-row-demo .drag-btn {
        cursor: move;
        font-size: 12px;
    }
    .main{
        width: 100%;
        height: 100%;
        background-color: white;
        float: left;
        margin-top: 10px;
    }
    .queryButton{
        border: 1px solid #e8eaec;
        padding:1px;
    }
    .bt1{
        margin:2px;
    }
    .queryParam{
        float: left;
        margin: 5px 10px;
    }
    /*.main .ant-form-item-control{*/
    /*    width:220px;*/
    /*}*/
</style>